import { Injectable, inject, signal } from '@angular/core';

import { STORAGE_KEYS } from './storage-keys';
import { StorageService } from './storage.service';

@Injectable({ providedIn: 'root' })
export class SidebarStateService {
  private readonly storage = inject(StorageService);

  private readonly _collapsed = signal<boolean>(this.storage.getJson(STORAGE_KEYS.pref.sidebarCollapsed, false));

  public readonly collapsed = this._collapsed.asReadonly();

  public toggle(): void {
    this.set(!this._collapsed());
  }

  public set(value: boolean): void {
    this._collapsed.set(value);
    this.storage.setJson(STORAGE_KEYS.pref.sidebarCollapsed, value);
  }
}
